import { IconChevronDown } from '@tabler/icons-react';
import Link from 'next/link';
import Avatar from '@/components/common/icons/avatar';
import { RoleProtector } from '@/components/common/role-protector';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { useLogout } from '@/features/auth/hooks/use-logout';
import { UserRole } from '@/features/auth/types';
export const ProfileMenu = () => {
  const {
    mutateAsync: logout
  } = useLogout();
  const {
    data: user
  } = useCurrentUser();
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="ProfileMenu" data-sentry-source-file="profile-menu.tsx">
      <DropdownMenuTrigger className="inline-flex items-center w-full justify-center gap-x-1.5" data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="profile-menu.tsx">
        <Avatar data-sentry-element="Avatar" data-sentry-source-file="profile-menu.tsx" />
        <IconChevronDown className="-mr-1 h-5 w-5 text-gray-700" aria-hidden="true" data-sentry-element="IconChevronDown" data-sentry-source-file="profile-menu.tsx" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48 bg-background mr-xxs mt-1" data-sentry-element="DropdownMenuContent" data-sentry-source-file="profile-menu.tsx">
        <DropdownMenuLabel className="bg-gray-50 px-4 py-3 text-md font-medium" data-sentry-element="DropdownMenuLabel" data-sentry-source-file="profile-menu.tsx">
          @{user?.username}
        </DropdownMenuLabel>
        <RoleProtector roles={[UserRole.ADMIN]} data-sentry-element="RoleProtector" data-sentry-source-file="profile-menu.tsx">
          <DropdownMenuItem className="px-4 py-3" asChild data-sentry-element="DropdownMenuItem" data-sentry-source-file="profile-menu.tsx">
            <Link href={'/admin'} className="text-body font-medium" data-sentry-element="Link" data-sentry-source-file="profile-menu.tsx">
              Admin Dashboard
            </Link>
          </DropdownMenuItem>
        </RoleProtector>
        <DropdownMenuItem className="px-4 py-3" asChild data-sentry-element="DropdownMenuItem" data-sentry-source-file="profile-menu.tsx">
          <Link href={'/orders'} className="text-body font-medium" data-sentry-element="Link" data-sentry-source-file="profile-menu.tsx">
            Orders
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="px-4 py-3" asChild data-sentry-element="DropdownMenuItem" data-sentry-source-file="profile-menu.tsx">
          <Link href={'/sellinghub'} className="text-body font-medium" data-sentry-element="Link" data-sentry-source-file="profile-menu.tsx">
            Seller Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="px-4 py-3" onClick={() => logout()} data-sentry-element="DropdownMenuItem" data-sentry-source-file="profile-menu.tsx">
          {' '}
          <p className="text-body font-medium">Logout</p>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>;
};